import { Section, Chapter, Reveal } from "./Section";
import { scrollTo } from "./Navbar";
import { Magnetic } from "./fx";
import { Flame, Crown, Mic, Users, Megaphone, Compass, HeartHandshake, ArrowRight } from "lucide-react";

const AREAS = [
  [Flame, "Prophetic Ministry"],
  [Crown, "Leadership Development"],
  [Mic, "Preaching & Teaching"],
  [Users, "Conferences & Revivals"],
  [Megaphone, "Motivational Speaking"],
  [Compass, "Mentorship"],
  [HeartHandshake, "Life Coaching"],
];

export default function Ministry() {
  return (
    <Section id="ministry" testid="ministry-section" className="bg-white/[0.015]">
      <div className="grid lg:grid-cols-12 gap-14">
        <div className="lg:col-span-5">
          <Chapter number="02" label="Ministry" testid="ministry-chapter"
            title={<>Prophetic Ministry<br />&amp; <span className="text-vg">Speaking</span></>}
            sub="A prophetic voice for today's Church — practical and prophetic messages that strengthen believers and prepare leaders for their next level of Kingdom assignment." />
          <Reveal delay={0.2} className="mt-8">
            <p className="text-base sm:text-lg text-slate-300 leading-relaxed font-normal max-w-md">
              Helping people understand who they are, what God has placed within them, and how to effectively
              walk out their purpose — through preaching, teaching, conferences, leadership gatherings, and speaking engagements.
            </p>
            <Magnetic>
              <a href="#invite" data-testid="ministry-invite-btn" onClick={(e) => { e.preventDefault(); scrollTo("#invite"); }}
                className="group mt-8 inline-flex items-center gap-2 px-7 py-3.5 rounded-full bg-gradient-to-r from-amber-400 to-violet-500 text-white text-sm font-bold uppercase tracking-[0.12em] shadow-[0_10px_35px_-10px_rgba(139,92,246,0.7)] hover:brightness-110 transition-all duration-300">
                Invite Prophet Turner <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
              </a>
            </Magnetic>
          </Reveal>
        </div>
        <div className="lg:col-span-7 grid sm:grid-cols-2 gap-4 content-start">
          {AREAS.map(([Icon, label], i) => (
            <Reveal key={label} delay={0.06 * i}>
              <div data-testid={`ministry-area-${label.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="group card-hover glass flex items-center gap-4 rounded-2xl px-6 py-5">
                <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-gradient-to-br from-violet-500/25 to-amber-500/25 border border-white/10 text-violet-300 group-hover:from-violet-500 group-hover:to-amber-400 group-hover:text-white transition-all duration-300">
                  <Icon size={18} />
                </span>
                <span className="font-display text-xl font-bold text-slate-100">{label}</span>
              </div>
            </Reveal>
          ))}
        </div>
      </div>
    </Section>
  );
}
